@if(!showEmptyState) {
  <figure [attr.data-qa]="chartId" class="highcharts-figure">
    <div class="{{height}} margin-unset" [id]="chartId"></div>
  </figure>
} @else {
  <app-empty-chart [additionalStyle]="height" [circle]="false"></app-empty-chart>
}
